<!--
 * @Author: liuwei
 * @Date: 2020-12-02 10:09:53
 * @LastEditTime: 2020-12-05 14:17:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yq-act-web\src\views\hlb-purchase-act\rules.vue
-->
<template>
  <div class="rules">
    <!-- <img :src="imgHost + 'kv.jpg'" alt=""> -->
    <div class="logo">
      <img :src="imgHost + 'logo_bg1.png'" />
    </div>
    <div class="rules-box">
      <div class="r-body">
        <div class="r-title">游戏规则</div>
        <div class="titlt-h">竞猜规则</div>
        <p>1、竞猜环节开放期限：<span class="yellow">2024年6月14日 --- 2024年7月15日02:00。</span></p>
        <p>2、小组赛的竞猜选项包括：主场胜、平、客场胜。</p>
        <p>3、小组赛后的淘汰赛制，竞猜选项包括：主场胜、客场胜。</p>
        <p>4、用户每场比赛只能进行1次竞猜。</p>
        <p>5、竞猜结果一旦提交，不可更改。</p>
        <p>6、比赛开始前1小时，将停止该场比赛的竞猜。</p>

        <div class="titlt-h">澳朵金豆累计规则</div>
        <p>1、猜对比赛结果，根据对应赛事奖励相应的澳朵金豆。</p>
        <p>2、猜错比赛结果，不扣除澳朵金豆，但也不获得澳朵金豆奖励。</p>
        <p>
          3、每周公布澳朵金豆榜单，获得周排名第一名将额外获得80个澳朵金豆奖励，第二名获得50个澳朵金豆奖励，第三名获得30个澳朵金豆奖励。
        </p>
        <p >
          4、在欧洲杯活动期间，参与澳朵花园线下欧洲杯主题活动一次可获得100个澳朵金豆奖励，<span style="font-weight: 700;font-size: 14px; color: #000;">每人最多可参加3次线下到访活动</span>。
        </p>
        <p>(1)用户须参与欧洲杯线上竞猜活动，且到澳朵花园现场参与线下活动。</p>
        <p>(2)现场提供截图给会籍顾问，在竞猜主页面中，截图“我的“界面。</p>
        <p>5、周排行前三名以及参与线下活动，奖励的澳朵金豆将在 <span class="yellow">赛程最后一天（2024年7月15日）统一添加。</span></p>
        <div class="titlt-h">获得额外红包奖励</div>
        <p >
          1.点击<span style="font-weight: 700;font-size: 14px; color: #000;">界面右上方</span>，分享链接，邀请好友参与线上竞猜，即可额外获得红包奖励。
        </p>
        <p>2.被邀请好友需要通过分享链接参与线上竞猜，才记为分享成功。</p>
        <p > <span style="font-weight: 700;font-size: 14px; color: #000;">3.该红包奖励仅发放给分享者，每人最多可获得20个红包奖励。</span></p>

        <div class="titlt-h">澳朵金豆兑换规则</div>
        <p>
          1、用户累计的澳朵金豆可在2024年7月15日（欧洲杯赛程全部结束后）用于兑换礼品。
        </p>
        <p>2、兑换礼品开放期限：<span class="yellow">2024年7月15日 --- 2024年7月31日。</span></p>
        <p>
          3、所有澳朵金豆均须在有限期内使用，恕不补发、更换、延长期限或折换现金。
        </p>
        <p>
          4、兑换详情以及其他各类宣传品中的礼品、奖品图片仅供参考，其颜色、外观及款式以实物为准。
        </p>
        <p>5、红包奖励每人最多可兑换5次。</p>
        <p>6、<span class="yellow">所有兑换礼品数量有限，先到先得。</span></p>
        <p>7、实物礼品，需要用户在线上兑换，线下领取。</p>
        <div class="titlt-h">注意事项</div>
        <p>1、用户参与活动即表示同意活动规则。</p>
        <p>2、活动期间，如发现作弊行为，主办方有权取消用户的参赛资格。</p>
        <p>3、主办方保留在法律允许范围内对活动规则进行解释和修改的权利。</p>
        <p>4、关于一切有关本活动的问题，澳朵花园保留解释权或最终决定权。</p>
        <p>5、本次活动最终解释权归开发商所有。</p>

        <div class="b-bottom">
          <!-- <span>领奖地址</span>
          <div class="table">
            <div class="th">
              <div class="td">项目名称</div>
              <div class="td">领奖地址</div>
            </div>
            <div class="tr" v-for="(item, index) in addList" :key="index">
              <div class="td">{{item.projectName}}</div>
              <div class="td">{{item.addressName}}</div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="js">
        本次活动由慈溪益坤置业有限公司在法律法规范围内保留最终解释权
      </div> -->
    </div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
// import Vue from "vue/dist/vue.js";
export default {
  name: "",
  components: {},
  data() {
    return {
      addList: [
        {
          projectName: "修文山湖海·上城",
          addressName: "贵阳白修线旁，玩意窝公园内",
        },
        {
          projectName: "遵义山湖海·瑞府",
          addressName: "遵义新蒲天鹅湖新蒲汇旁",
        },
        {
          projectName: "永兴山湖海·上城",
          addressName: "永兴县西水路碧水小学旁（鸡公岭生态公园对面）",
        },
        {
          projectName: "安乡山湖海·上城",
          addressName: "常德市安乡县子龙路与纯银路交汇处",
        },
        {
          projectName: "汉寿山湖海·上城",
          addressName: "汉寿县龙阳镇汉寿大道东侧（人民医院往南300米）",
        },
        {
          projectName: "宜章山湖海·上城",
          addressName: "宜章大道山湖海上城（百通汽车站往东800米）",
        },
        {
          projectName: "汨罗山湖海·上城",
          addressName: "汨罗市楚天路正则学校西门对面",
        },
        {
          projectName: "赤壁山湖海·悦府",
          addressName: "蒲圻大道与北山大道交汇处（赤壁北站以东）",
        },
      ],
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
    // console.log(`当前城市名称--->${this.$root.curLocation.location}-----当前infoId--->${this.$root.curLocation.infoId}`)
    // this.$config.infoId = this.$root.curLocation.infoId; //在这个页面中infoId写死113
    // Vue.prototype.$infoId = this.$root.curLocation.infoId;
    // this.$httpdf
    //   .get(this.$apidf.xc_voice_purchase.getProjectsAddress, { infoId: this.$config.infoId }, {
    //     res: "data",
    //     infoId: this.$infoId || 0
    //   })
    //   .then((data) => {
    //     if (data.code == 0) {
    //       this.addList = data.data;
    //     }
    //   });
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
.rules {
  width: 100%;
  // min-height: 100vh;
  // background: #BEDDEA url( $imgHost + 'rule_bg.jpg?t=8') 0 0 / 100% no-repeat;

  background: #0e8fb9 url($imgHost + "bg.jpg") 0 0 / 100% no-repeat;
  // padding-bottom: 100px;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  .rules-box {
    padding: 54px 15px 0;
    .r-body {
      background: #EBF3E8;
      border:10px solid #36841B;
      border-radius: 15px;
      padding: 36px 20px 10px;
      box-sizing: border-box;
      margin-bottom: 40px;
    }
  }
}

.logo {
  width: $logoWidth;
  margin-top: 20px;
}
.r-title {
  width: 133px;
  height: 40px;
  font-size: 18px;
  line-height: 40px;
  background: #58a72a;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #fff;
  position: absolute;
  left: 50%;
  top: -8px;
  text-align: center;
  transform: translateX(-50%);
}
.titlt-h{
  color: #023055;
  font-weight: 700;
  font-size: 14px;
  line-height: 26px;
}

.r-body {
  margin-top: 15px;
  box-sizing: border-box;
  width: 100%;
  height: auto;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 22px;
  letter-spacing: 1px;
  position: relative;
  z-index: 1;
  text-align: justify;
  text-justify: inter-ideograph;
  span {
    font-weight: bold;
  }
  .b-bottom {
    margin-top: 20px;
    width: 100%;
    > span {
      display: block;
      text-align: center;
    }

    .table {
      border: 1px solid #fff;
      text-align: center;
      .th {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fefefe;
        line-height: 24px;
      }
      .tr {
        display: flex;
        align-items: center;
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #fefefe;
        line-height: 15px;
        border-top: 1px solid #fff;
      }
      .td {
        flex: 3;
        padding: 10px 0;
        &:nth-child(2) {
          flex: 6;
          border-left: 1px solid #fff;
          border-right: 1px solid #fff;
        }
        &:nth-child(3) {
          flex: 4;
        }
      }
    }
  }
}
.js {
  width: 100%;
  height: 10px;
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 12px;
  color: #333;
  text-align: center;
  margin-top: 15px;
}
.yellow{
  background-color: yellow;
}
.hys{
  color: red;
}
p{
  padding: 0;
  color: #666;
}
</style>
